/**
 * Workspace API functions (ADP-66, trimmed by ADP-167).
 *
 * The main/sub-account model replaced multi-workspace management: every user
 * belongs to exactly one Workspace, so switching/creating Workspaces and the
 * member-management endpoints are gone. What remains is the read/rename
 * surface for the single Workspace.
 */
import { type WorkspaceProfile, WorkspaceProfileSchema } from "@adpilot/shared";

import { api } from "./api";

export async function updateWorkspaceName(
  workspaceId: string,
  name: string,
): Promise<{ id: string; name: string }> {
  const res = await api
    .patch(`workspaces/${workspaceId}`, { json: { name } })
    .json<{ success: true; data: { workspace: { id: string; name: string } } }>();
  return res.data.workspace;
}

export async function fetchWorkspaceProfile(workspaceId: string): Promise<WorkspaceProfile> {
  const res = await api
    .get(`workspaces/${workspaceId}`)
    .json<{ success: true; data: { workspace: unknown } }>();
  return WorkspaceProfileSchema.parse(res.data.workspace);
}
